import { Head } from '@inertiajs/react'
import { DealsTable } from '@/components/deals-table'

export default function Index() {
  return (
    <>
      <Head title="Inbox" />
        <DealsTable title="Inbox" subtitle="Deals that need your attention. The goal is inbox zero." />
    </>
  )
}
